var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mb-12 mb-lg-0",attrs:{"fluid":_vm.$vuetify.breakpoint.md}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_c('v-card',{attrs:{"width":"100%"}},[_c('v-card-title',{staticClass:"d-block text-center font-weight-bold primary white--text pa-1",staticStyle:{"word-break":"normal"}},[_vm._v("AYUDA")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }